import { MapPolylinePoint } from './map.polylinePoint';
import { MapLatLng } from './map.latlng';

export abstract class MapPolyline {
    public id: number;       // Identificador secuencial
    public map: any;         // Mapa nativo
    public polyline: any;    // Polilinea ativa
    public color: string;
    public opacity: number;
    public weight: number;
    public points: MapPolylinePoint[] = [];

    constructor(id: number, map: any, color: string, opacity: number, weight: number) {
        this.id = id;
        this.map = map;
        this.color = color;
        this.opacity = opacity;
        this.weight = weight;
    }

    abstract remove(): any;
    abstract addPoint(id: number, content: string, position: MapLatLng): MapPolylinePoint;
    abstract getNearbyPoint(position: any): MapPolylinePoint;
}
